var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59499 2C8.82313 2 9.04193 2.09031 9.20325 2.25105C9.36457 2.4118 9.4552 2.62981 9.4552 2.85714V21.1429C9.4552 21.6162 9.07007 22 8.59499 22C8.11991 22 7.73478 21.6162 7.73478 21.1429V9.42857H2.86024C2.51231 9.42857 2.19865 9.21974 2.0655 8.89944C1.93236 8.57915 2.00596 8.21048 2.25198 7.96534L7.98673 2.25105C8.14805 2.09031 8.36685 2 8.59499 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.405 22C15.6332 22 15.852 21.9097 16.0133 21.749L21.748 16.0347C21.994 15.7895 22.0676 15.4209 21.9345 15.1006C21.8014 14.7803 21.4877 14.5714 21.1398 14.5714H16.2652V2.85714C16.2652 2.38376 15.8801 2 15.405 2C14.9299 2 14.5448 2.38376 14.5448 2.85714V21.1429C14.5448 21.3702 14.6354 21.5882 14.7967 21.749C14.9581 21.9097 15.1769 22 15.405 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferAlt);
export default __webpack_public_path__ + "static/media/transfer-alt.a3d81bd4b7409ca378c67d0125560c0e.svg";
export { ForwardRef as ReactComponent };